import React from "react"
import Ionicon from 'react-ionicons'

const normalizeChildren = children => (
  children.map ? children : [children]
)

const Row = ({ children, height }) => (
  <div className="flex-row">
    {
      normalizeChildren(children).map((child, i) => (
        <div key={i} style={{ height }}>
          {child}
        </div>
      ))
    }
  </div>
)

const PaulaBox = ({ label, onClick, image }) => (
  <div className="paula-box" onClick={() => onClick && onClick()} style={{ backgroundImage: `url(${image})` }}>
    <label>{label}</label>
  </div>
)

/**
 *
 */

export const TransportationButtons = ({ city, goto }) => (
  <div className="taxiButtonWrapper">
    <button className="taxiButton resetButton" onClick={() => goto(`/catalogo/${city.id}/transportation`)}>
      <Ionicon fontSize="42px" icon="ios-car" color="white"/>
      <span>打车</span>
    </button>
  </div>
)

function getCityButtons(cityId, gotoSearch) {
  if (cityId == "Barcelona") return [
    [ { label: "餐厅", onClick: gotoSearch("2sn6dbecc3"), image: "/static/cool/barcelona_restaurants.jpg" }, ],
    [ { label: "门票", onClick: gotoSearch("80ulgbfn21"), image: "/static/cool/barcelona_tickets.jpg" },
      { label: "购物", onClick: gotoSearch("chzlh8hklq"), image: "/static/cool/barcelona_shopping.jpg" }, ],
    [ { label: "高迪", onClick: gotoSearch("nif3nva43p"), image: "/static/cool/barcelona_gaudi.jpg" }, ]
  ]
  else if (cityId == "Málaga") return [
    [ { label: "餐厅", onClick: gotoSearch("2sn6dbecc3"), image: "/static/cool/portada_malaga_restaurantes@2x.jpg" },
      { label: "门票", onClick: gotoSearch("80ulgbfn21"), image: "/static/cool/portada_malaga_entradas@2x.jpg" } ]
  ]
  else if (cityId == "Sevilla") return [
    [ { label: "餐厅", onClick: gotoSearch("2sn6dbecc3"), image: "/static/cool/portada_sevilla_comer@2x.jpg" },
      { label: "门票", onClick: gotoSearch("80ulgbfn21"), image: "/static/cool/portada_sevilla_entradas@2x.jpg" } ]
  ]
  else if (cityId == "Granada") return [
    [ { label: "餐厅", onClick: gotoSearch("2sn6dbecc3"), image: "/static/cool/portada_malaga_restaurantes@2x.jpg" },
      { label: "门票", onClick: gotoSearch("80ulgbfn21"), image: "/static/uploads/c0aba71f764f35b69de3ffe6def52ef9.jpg" } ]
  ]
  else if (cityId == "valencia") return [
    [ { label: "门票", onClick: gotoSearch("80ulgbfn21"), image: "/static/uploads/1dbf68b00a42686d728ff69ea78f30db.jpeg" } ]
  ]
  else return [
    [ { label: "餐厅", onClick: gotoSearch("2sn6dbecc3"), image: "/static/cool/madrid_restaurants@2x.jpg" }, ],
    [ { label: "门票", onClick: gotoSearch("80ulgbfn21"), image: "/static/cool/madrid_tickets@2x.jpg" },
      { label: "购物", onClick: gotoSearch("chzlh8hklq"), image: "/static/cool/madrid_shopping@2x.jpg" }, ],
  ]
}

// #TODO this could be detected from what each city has
export const citiesWoButtons = new Set([
  "lisboa", "Segovia"
])

export const NewCityButtons = ({ city, gotoSearch }) => {
  if (citiesWoButtons.has(city._id)) return ""
  
  const buttons = getCityButtons(city._id, gotoSearch)
  
  return (
    <div className="city-buttons">
      {
        buttons.map(row => (
          <Row key={row[0].label} height="15vh">
            {row.map(button => <PaulaBox key={button.label} {...button} />)}
          </Row>
        ))
      }
    </div>
  )
}

export default NewCityButtons



// WEBPACK FOOTER //
// ./src/app/catalogo/City/CityPage.Buttons.jsx